module.exports = __webpack_public_path__ + "img/bg_top.3ae164d9.jpg";